import { useEffect } from "preact/hooks";
import { useApp } from "~/core/store";

const useTitle = (pageTitle: string) => {
    const { meta } = useApp();

    useEffect(() => {
        meta.title.value = pageTitle;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageTitle]);
};

export default useTitle;
